import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AsyncThunk } from '@reduxjs/toolkit';

import { PAGE_SIZE } from 'utils/constants';

import { IFilterValues, PaginationParams, SortPaginationParams } from 'models';

import { useAppDispatch } from './useAppDispatch';
import { useFiltersData } from './useFiltersData';

export const useMyInvestmentTable = ({
	values,
	initialValueSort,
	isGet,
	getCallback,
	downloadCallback,
}: {
	values: IFilterValues;
	initialValueSort: string;
	isGet: boolean;
	getCallback: AsyncThunk<void, SortPaginationParams, {}>;
	downloadCallback: AsyncThunk<void, PaginationParams, {}>;
}) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const [sort, setSort] = useState(initialValueSort);

	const page = Number(searchParams.get('page') || 1);

	const { filtersData } = useFiltersData(values);

	const onChange = (pagination: any, filters: any, sorter: any, current: any) => {
		const value = sorter.order
			? sorter.order === 'descend'
				? `-${sorter.field}`
				: sorter.field
			: '';

		const currentPage = current.action === 'sort' ? 1 : pagination.current;

		setSearchParams({ ...searchParams, ...values, page: currentPage });

		if (current.action !== 'paginate') {
			setSort(value);
		}
	};

	const dispatch = useAppDispatch();

	useEffect(() => {
		const isNotValid =
			filtersData.minInterestRate?.endsWith('.') ||
			filtersData.maxInterestRate?.endsWith('.') ||
			+filtersData.minInterestRate > +filtersData.maxInterestRate ||
			filtersData.minAmount?.endsWith('.') ||
			filtersData.maxAmount?.endsWith('.') ||
			+filtersData.minAmount > +filtersData.maxAmount;

		if (isNotValid) {
			return;
		}

		if (isGet && values) {
			dispatch(
				getCallback({
					page,
					size: PAGE_SIZE,
					sort,
					...filtersData,
				}),
			);
		}
	}, [dispatch, filtersData, getCallback, isGet, page, sort]);

	const onDownload = () => {
		dispatch(downloadCallback(filtersData));
	};

	return { page, setSearchParams, filtersData, sort, onChange, onDownload };
};
